import styled from "styled-components";

export const FaqContainer = styled.div`
  display: flex;
  width: 100%;
`;

export const ExpanderSection = styled.div`
  flex: 1 1 auto;
  width: 100%;
  padding-bottom: 1em;
`;
